var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffirm = function SvgAffirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Affirm 61*38"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h61v38H0z",
    "data-name": "Rectangle 25324"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 22.244c-.754 0-1.139-.372-1.139-.982 0-1.139 1.27-1.522 3.586-1.768a2.57 2.57 0 0 1-2.454 2.75Zm1-8.533a8.2 8.2 0 0 0-4.592 1.6l.944 1.993a5.43 5.43 0 0 1 3.376-1.408c1.149 0 1.784.384 1.784 1.159 0 .52-.42.783-1.214.887-2.969.384-5.3 1.2-5.3 3.492 0 1.813 1.291 2.911 3.308 2.911a3.9 3.9 0 0 0 3.331-1.85v1.566h2.68v-6.56c0-2.7-1.877-3.8-4.323-3.8Z",
    "data-name": "Path 5963"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M31.94 14.005v10.044h2.872v-4.84c0-2.3 1.392-2.975 2.361-2.975a2.2 2.2 0 0 1 1.228.363l.525-2.655a3.3 3.3 0 0 0-1.281-.232 3.04 3.04 0 0 0-3.015 1.985v-1.69Z",
    "data-name": "Path 5964"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.239 13.71a3.98 3.98 0 0 0-3.245 1.762 3.545 3.545 0 0 0-6.158.051v-1.519h-2.77v10.044h2.875v-5.171c0-1.85.972-2.746 1.879-2.746.821 0 1.576.531 1.576 1.9v6.015h2.87v-5.171c0-1.877.948-2.746 1.9-2.746.76 0 1.566.552 1.566 1.882v6.035h2.87v-6.941a3.163 3.163 0 0 0-3.354-3.395",
    "data-name": "Path 5965"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.949 14.004h-2.6v-1.02c0-1.329.759-1.708 1.412-1.708a2.9 2.9 0 0 1 1.281.32l.885-2.025a4.9 4.9 0 0 0-2.531-.586c-1.835 0-3.923 1.035-3.923 4.282v.739h-4.35v-1.022c0-1.329.757-1.708 1.412-1.708a2.7 2.7 0 0 1 1.281.32l.885-2.025a5.05 5.05 0 0 0-2.529-.586c-1.835 0-3.923 1.035-3.923 4.282v.739h-1.662v2.215h1.667v7.829h2.87v-7.831h4.353v7.829h2.87v-7.829h2.6Z",
    "data-name": "Path 5966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.53 14.005h-2.867v10.039h2.867Z",
    "data-name": "Path 5967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4af4",
    fillRule: "evenodd",
    d: "M26.768 12.298h2.808a14.7 14.7 0 0 1 13.807-9.679c8.039 0 14.987 6.121 14.987 15.649a19.6 19.6 0 0 1-.8 5.78h2.726l.027-.094a23 23 0 0 0 .675-5.678C61.001 7.651 53.257.003 43.389.003a17.5 17.5 0 0 0-16.62 12.3Z",
    "data-name": "Path 5968"
  })))));
};
export { SvgAffirm as ReactComponent };
export default "/_next/static/images/affirm.svg";